var map = {
	"./chartjs/chartjs.module": [
		"./src/app/chartjs/chartjs.module.ts",
		"chartjs-chartjs-module"
	],
	"./company/company.module": [
		"./src/app/company/company.module.ts",
		"default~company-company-module~dashboard-dashboard-module~pages-pages-module~user-user-module",
		"default~company-company-module~components-components-module~dashboard-dashboard-module",
		"default~company-company-module~dashboard-dashboard-module"
	],
	"./components/components.module": [
		"./src/app/components/components.module.ts",
		"default~company-company-module~components-components-module~dashboard-dashboard-module",
		"components-components-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"default~company-company-module~dashboard-dashboard-module~pages-pages-module~user-user-module",
		"default~company-company-module~components-components-module~dashboard-dashboard-module",
		"default~company-company-module~dashboard-dashboard-module",
		"dashboard-dashboard-module"
	],
	"./icons/icons.module": [
		"./src/app/icons/icons.module.ts",
		"icons-icons-module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"default~company-company-module~dashboard-dashboard-module~pages-pages-module~user-user-module",
		"pages-pages-module"
	],
	"./user/user.module": [
		"./src/app/user/user.module.ts",
		"default~company-company-module~dashboard-dashboard-module~pages-pages-module~user-user-module",
		"user-user-module"
	],
	"./widgets/widgets.module": [
		"./src/app/widgets/widgets.module.ts",
		"widgets-widgets-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;